import React from "react";
import { Text, View } from "native-base";
import { Copy } from "lucide-react-native";
import PressableWrap from "../../../Universal/Buttons/PressableColorWrap/PressableColorWrap";
import PressableWrapp from "../../../Universal/Buttons/PressableReact/PressableWrapp";
import { DeanteData } from "../../../Universal/API/Context-API/AppProvider";
import { normalizeText } from "./helpers";
import { UnitFullV2Styles } from "./styles";

interface UnitFullV2HeaderProps {
  currentUnit: DeanteData;
  isSmallVersion: boolean;
  quickFacts: string[];
  scaleAll: number;
  styles: UnitFullV2Styles;
  onCopyArt: (art: string) => void;
  onGoToCollection: (collectionName: string) => void;
}

const UnitFullV2Header: React.FC<UnitFullV2HeaderProps> = ({
  currentUnit,
  isSmallVersion,
  quickFacts,
  scaleAll,
  styles,
  onCopyArt,
  onGoToCollection,
}) => (
  <View style={styles.headerBlock}>
    <Text
      style={[
        styles.title,
        { fontSize: (isSmallVersion ? 19 : 28) * scaleAll },
      ]}
    >
      {currentUnit.name}
    </Text>

    <View style={styles.headerMetaRow}>
      {normalizeText(currentUnit.col) ? (
        <PressableWrap
          onPress={() => onGoToCollection(currentUnit.col)}
          style={styles.collectionChipPress}
        >
          <View style={styles.collectionChip}>
            <Text style={styles.collectionChipText}>{currentUnit.col}</Text>
          </View>
        </PressableWrap>
      ) : null}

      {normalizeText(currentUnit.art) ? (
        <PressableWrapp
          style={styles.inlineAction}
          onPress={() => onCopyArt(currentUnit.art)}
        >
          <Copy size={14 * scaleAll} color="#101010" />
          <Text style={styles.inlineActionText}>{currentUnit.art}</Text>
        </PressableWrapp>
      ) : null}

      {quickFacts.length ? (
        <View style={styles.quickFactsWrap}>
          {quickFacts.map((fact) => (
            <View key={fact} style={styles.quickFactChip}>
              <Text style={styles.quickFactText}>{fact}</Text>
            </View>
          ))}
        </View>
      ) : null}
    </View>
  </View>
);

export default React.memo(UnitFullV2Header);
